import {AbstractModel} from '../abstract-model';
import {Stat} from './stat';

export class GlobalHomeStat extends AbstractModel {
  today: Stat = new Stat();
  wtd: Stat = new Stat();
  week: Stat = new Stat();
  mtd: Stat = new Stat();
  month: Stat = new Stat();
  ytd: Stat = new Stat();
  year: Stat = new Stat();
}
